<template>
    <button class="assistent-chat-detail-menu-item-button" type="button">
        <svg-icon
            is-custom-icon
            :icon="props.inboxFolder.icon"
            :color="active ? 'primary' : 'gray-400'"
            :size="IconSize.sm"
        />

        <text-decorator :color="active ? 'primary' : 'gray-800'" :bold="active">
            {{ props.inboxFolder.label }}
        </text-decorator>

        <div class="assistent-chat-detail-menu-item-button__counts">
            <div v-if="alertCount > 0">
                {{ alertCount }}
            </div>
            <div>
                {{ count }}
            </div>
        </div>
    </button>
</template>

<script setup lang="ts">
    import { IconSize } from '@keyvue/one-ui';
    import type InboxFolder from '@/ai/assistent/types/InboxFolder';

    const props = defineProps<{
        inboxFolder: InboxFolder
        count: number,
        alertCount: number,
        active?: boolean,
    }>();
</script>

<style scoped lang="scss">
    .assistent-chat-detail-menu-item-button {
        display: flex;
        gap: size(sm);
        width: 100%;
        border: none;
        background: none;
        padding: 0;
        align-items: center;
        cursor: pointer;
        font-size: font-size(sm);

        &__counts {
            margin-left: auto;
            display: flex;
            align-items: center;
            height: 100%;
            gap: size(xs);

            & > div {
                display: flex;
                align-items: center;
                justify-content: center;
                min-width: 15px;
                box-sizing: border-box;
                padding: 0 size(xs);
                height: 15px;
                border-radius: 8px;
                background-color: var(--theme-colors-default--red-500);
                color: white;
                font-size: size(sm);

                &:last-child {
                    background-color: var(--theme-colors-default--gray-200);
                    color: var(--theme-colors-default--primary);
                    font-weight: bold;
                }
            }
        }
    }
</style>
